/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {BaseFieldType} from 'compob2b-libs';

@Component({
    selector: 'app-product-link',
    templateUrl: './product-link.component.html',
    standalone: false
})
export class ProductLinkComponent extends BaseFieldType {

  constructor(private readonly route: Router) {
    super();
  }

  showProduct(id: string) {
    const uri = '/cabinet/pim/catalog/item/edit/' + id;
    this.route.navigate(['/'], {skipLocationChange: true}).then(() =>
      this.route.navigate([uri]));
  }
}
